module.exports = __webpack_public_path__ + "static/media/third-party-black-icon.7bc376ab.svg";